<template>
  <span
    v-if="catalog.isRefreshing || catalog.finishedAt"
    class="hidden md:inline-flex items-center gap-1.5 text-sm text-gray-500"
    role="status"
    :title="catalog.finishedAt ? useDayjs(catalog.finishedAt).format('D. M. YYYY HH:mm') : undefined"
  >
    <Icon
      v-if="catalog.isRefreshing"
      name="loading-02"
      class="w-3.5 h-3.5 animate-spin"
    />
    {{ label }}
  </span>
</template>

<script setup>
// Refs
const catalog = useCatalogStore();
// Ticks so "2m ago" keeps counting without a new sweep.
const now = useNow({ interval: 30 * 1000 });

// Computed
const label = computed(() => {
  if (catalog.isRefreshing) {
    return useT('catalog.syncing');
  }

  return useT('catalog.lastSynced', { time: now.value && useFormatRelative(catalog.finishedAt, { empty: '' }) });
});
</script>
